/* CPAP Discount Warehouse — Store Locator (Horizon theme port)
   Generated from the Claude Design prototype by build-js.mjs. Do not hand-edit;
   edit the prototype + replacements and regenerate. */
/* ============================================================
   CDW Store Locator — vanilla JS
   Theme-friendly, no framework. Leaflet for the interactive map.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = document.querySelector('.cdw-locator') || document;

  /* ---------- icon set (Lucide-style line icons, 24×24) ---------- */
  var I = {
    search:'<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
    phone:'<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.66A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>',
    user:'<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    cart:'<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    menu:'<path d="M4 6h16M4 12h16M4 18h16"/>',
    x:'<path d="M18 6 6 18M6 6l12 12"/>',
    crosshair:'<circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/><circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none"/>',
    map:'<path d="m9 6-6 3v12l6-3 6 3 6-3V6l-6 3-6-3z"/><path d="M9 6v12M15 9v12"/>',
    pin:'<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/>',
    star:'<path d="M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.1 6.47L12 17.3 6.2 20.4l1.1-6.47L2.6 9.35l6.5-.95z" fill="currentColor" stroke="none"/>',
    moon:'<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>',
    bag:'<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/>',
    box:'<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3 8 9 5 9-5M12 13v8"/>',
    nav:'<path d="M3 11l19-9-9 19-2-8-8-2z"/>',
    ext:'<path d="M7 17 17 7M8 7h9v9"/>',
    clock:'<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    check:'<path d="M20 6 9 17l-5-5"/>',
    chev:'<path d="m6 9 6 6 6-6"/>',
    building:'<path d="M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"/><path d="M9 7h2M9 11h2M9 15h2M16 21h4V11h-4"/><path d="M2 21h20"/>',
    calendar:'<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>',
    headset:'<path d="M3 14v-2a9 9 0 0 1 18 0v2"/><path d="M21 16a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2zM3 16a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2z"/>',
    truck:'<path d="M14 18V6a1 1 0 0 0-1-1H2v13M14 9h4l3 3v5h-7"/><circle cx="6.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/>',
    shield:'<path d="M12 2 4 5v6c0 5 3.5 8 8 11 4.5-3 8-6 8-11V5z"/><path d="m9 12 2 2 4-4"/>',
    info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    bed:'<path d="M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8M3 14h18M7 10V8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>',
    mail:'<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>',
    file:'<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h6"/>',
    heart:'<path d="M19 14c1.5-1.5 3-3.4 3-5.5A4.5 4.5 0 0 0 12 5.5 4.5 4.5 0 0 0 2 8.5C2 12 5 14.5 12 21c7-6.5 7-9 7-7z"/>'
  };
  function svg(name, w) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" width="' + (w || 24) + '" height="' + (w || 24) + '" aria-hidden="true">' +
      (I[name] || '') + '</svg>';
  }
  // hydrate static [data-icon] spans
  ROOT.querySelectorAll('[data-icon]').forEach(function (el) { el.innerHTML = svg(el.getAttribute('data-icon'), 20); });

  /* ---------- type config ---------- */
  var TYPE = {
    brand:                { cls:'brand',     label:'Retail & fitting store', chip:'Retail & fitting',      color:'#feb62c', icon:'star' },
    partner_sleep:        { cls:'sleep',     label:'Sleep study partner',   chip:'Sleep study partners',  color:'#043146', icon:'moon' },
    partner_clickcollect: { cls:'collect',   label:'Click & Collect',       chip:'Click & Collect',       color:'#2f86b4', icon:'bag'  },
    warehouse:            { cls:'warehouse', label:'Warehouse',             chip:'Warehouse',             color:'#6b6b6b', icon:'box'  }
  };
  var STATE_ORDER = ['SA','NT','VIC','QLD','WA','NSW','ACT','TAS'];
  var STATE_FULL  = { SA:'South Australia', NT:'Northern Territory', VIC:'Victoria', QLD:'Queensland', WA:'Western Australia', NSW:'New South Wales', ACT:'ACT', TAS:'Tasmania' };
  var SHARED_PHONE = '+61881660816'; // CLM Sleep central bookings line
  /* Locations that serve more than one role (not captured as separate rows in the dataset). */
  var DUAL_ROLE = {
    'elizabeth-elizabeth': ['partner_clickcollect'], // owned store is also a Click & Collect counter
    'kent-town-kent-town': ['partner_sleep']         // collect point is also a sleep study clinic
  };
  var CLS_OF = { brand:'brand', partner_sleep:'sleep', partner_clickcollect:'collect', warehouse:'warehouse' };
  var CLM_FALLBACK = 'https://www.clmsleep.com/contact-us/';

  /* ---------- helpers ---------- */
  function cleanPhone(raw){ if(!raw) return ''; var d = raw.replace(/[^\d+]/g,''); if(d.indexOf('+61')===0) d='0'+d.slice(3); return d.replace(/\D/g,''); }
  function fmtPhone(raw){
    var d = cleanPhone(raw);
    if(d.length===10 && d.indexOf('1800')===0) return d.slice(0,4)+' '+d.slice(4,7)+' '+d.slice(7);
    if(d.length===10 && d[0]==='0') return '('+d.slice(0,2)+') '+d.slice(2,6)+' '+d.slice(6);
    if(d.length===8) return d.slice(0,4)+' '+d.slice(4);
    return raw;
  }
  function telHref(raw){ var d=cleanPhone(raw); return 'tel:'+(d[0]==='0'?'+61'+d.slice(1):d); }
  function isShared(raw){ return cleanPhone(raw)===cleanPhone(SHARED_PHONE); }
  function directionsUrl(c){ return 'https://www.google.com/maps/dir/?api=1&destination='+c.lat+','+c.lng; }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];}); }
  function haversine(a, b){
    var R=6371, dLat=(b.lat-a.lat)*Math.PI/180, dLng=(b.lng-a.lng)*Math.PI/180;
    var s=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(a.lat*Math.PI/180)*Math.cos(b.lat*Math.PI/180)*Math.sin(dLng/2)*Math.sin(dLng/2);
    return R*2*Math.atan2(Math.sqrt(s),Math.sqrt(1-s));
  }
  function fmtDist(km){ return km<10 ? km.toFixed(1)+' km' : Math.round(km)+' km'; }
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     Build cards — merge co-located records (dual-role handling)
     ============================================================ */
  function normKey(r){ return (r.suburb+'|'+(r.host||'')).toLowerCase().trim(); }
  function isStudy(r){ return /sleep study/i.test(r.name); }

  function buildCards(rows){
    var groups = {}, order = [];
    rows.forEach(function(r){
      // only co-locate when a host venue is named (avoids merging unrelated sites)
      var key = r.host ? normKey(r) : ('solo:'+r.slug);
      if(!groups[key]){ groups[key]=[]; order.push(key); }
      groups[key].push(r);
    });
    var typeRank = { brand:0, partner_clickcollect:1, partner_sleep:2, warehouse:3 };
    return order.map(function(key){
      var g = groups[key].slice().sort(function(a,b){ return (typeRank[a.type]-typeRank[b.type]) || (isStudy(a)-isStudy(b)); });
      var base = g[0];
      var roles = {}; g.forEach(function(r){ roles[r.type]=true; if(isStudy(r)) roles.study=true; });
      (DUAL_ROLE[base.slug]||[]).forEach(function(t){ roles[t]=true; });
      var c = {
        slug: base.slug, name: base.name.replace(/\s*\(sleep study\)/i,''), host: base.host,
        street: base.street, suburb: base.suburb, state: base.state, postcode: base.postcode,
        phone: base.phone, email: base.email, lat: base.lat, lng: base.lng,
        type: base.type, cls: TYPE[base.type].cls, detail_strategy: base.detail_strategy,
        in_locations_json: base.in_locations_json, clm_url: base.clm_url, members: g, roles: roles
      };
      // every chip-class this card should surface under (primary + any extra roles)
      var fc = {}; fc[c.cls]=1; Object.keys(roles).forEach(function(t){ if(CLS_OF[t]) fc[CLS_OF[t]]=1; });
      c.filterCls = Object.keys(fc);
      // dual-role secondary note (subtle)
      c.dualNote = null;
      if(roles.partner_clickcollect && base.type!=='partner_clickcollect') c.dualNote='Also a Click & Collect pickup point';
      else if(roles.partner_sleep && base.type==='partner_clickcollect') c.dualNote='Also a CLM Sleep study clinic';
      else if(roles.study && base.type==='partner_sleep') c.dualNote='In-home sleep study testing arranged here';
      return c;
    });
  }

  var CARDS = buildCards(window.CDW_LOCATIONS || []);
  var BY_SLUG = {}; CARDS.forEach(function(c){ BY_SLUG[c.slug]=c; });

  /* type counts (post-merge) */
  var COUNTS = { brand:0, sleep:0, collect:0, warehouse:0 };
  CARDS.forEach(function(c){ c.filterCls.forEach(function(fc){ COUNTS[fc]++; }); });

  /* ============================================================
     Hero stats + filter chips
     ============================================================ */
  (function heroStats(){
    var states = {}; CARDS.forEach(function(c){ states[c.state]=1; });
    var stats = [
      { b: CARDS.length, s:'locations Australia-wide' },
      { b: Object.keys(states).length, s:'states &amp; territories' },
      { b: COUNTS.brand, s:'retail &amp; fitting store' }
    ];
    document.getElementById('hero-stats').innerHTML = stats.map(function(x){
      return '<div class="hero-stat"><b>'+x.b+'</b><span>'+x.s+'</span></div>';
    }).join('');
  })();

  var activeTypes = { brand:true, sleep:true, collect:true, warehouse:true };
  function renderChips(){
    var box = document.getElementById('filter-chips');
    var allOn = ['brand','sleep','collect','warehouse'].every(function(k){ return COUNTS[k]===0 || activeTypes[k]; });
    var chips = '<button class="chip all" data-chip="all" aria-pressed="'+allOn+'">'
      + '<span>All locations</span><span class="ct">'+CARDS.length+'</span></button>';
    [['brand','brand'],['partner_sleep','sleep'],['partner_clickcollect','collect'],['warehouse','warehouse']].forEach(function(p){
      var t = TYPE[p[0]], cls=p[1], n=COUNTS[cls], dis = n===0;
      chips += '<button class="chip '+cls+'" data-chip="'+cls+'" aria-pressed="'+(!dis && activeTypes[cls])+'"'+(dis?' disabled title="No locations of this type yet"':'')+'>'
        + '<span class="dot"></span><span>'+t.chip+'</span><span class="ct">'+n+'</span></button>';
    });
    box.innerHTML = chips;
  }

  /* ============================================================
     LIST rendering
     ============================================================ */
  var searchQ = '', nearestMode = false, userLoc = null, activeSlug = null;

  function matchesSearch(c){
    if(!searchQ) return true;
    var q = searchQ.toLowerCase();
    return [c.name, c.suburb, c.state, c.postcode, c.host].some(function(f){ return f && f.toLowerCase().indexOf(q)>-1; });
  }
  function visibleCards(){
    return CARDS.filter(function(c){ return c.filterCls.some(function(fc){ return activeTypes[fc]; }) && matchesSearch(c); });
  }

  function typeBadge(cls){
    var map = { brand:['brand','Retail & fitting','star'], sleep:['sleep','Sleep study partner','moon'], collect:['collect','Click & Collect','bag'], warehouse:['warehouse','Warehouse','box'] };
    var m = map[cls];
    return '<span class="type-badge '+m[0]+'">'+svg(m[2],13)+m[1]+'</span>';
  }

  function cardHTML(c){
    var t = c.cls;
    var distPill = (c.distanceKm!=null) ? '<span class="dist">'+svg('nav',12)+' '+fmtDist(c.distanceKm)+'</span>' : '';
    var phoneTxt = fmtPhone(c.phone);
    var phoneNote = isShared(c.phone) ? '<span class="tag-note">CLM Sleep bookings</span>' : '';
    var addrFull = esc(c.street)+', '+esc(c.suburb)+' '+esc(c.state)+' '+esc(c.postcode);

    var head = '<div class="card-top">'+typeBadge(t)+distPill+'</div>';
    var titleLink = (t==='sleep'||t==='collect')
      ? '<a href="#/store/'+esc(c.slug)+'">'+esc(c.name)+'</a>'
      : esc(c.name);
    var title = '<h3>'+titleLink+'</h3>';
    var host = c.host ? '<div class="host">'+esc(c.host)+'</div>' : '';

    var body='', actions='';

    if(t==='warehouse'){
      // non-service site — suburb + phone ONLY, muted
      body = '<div class="meta-line">'+svg('pin',15)+esc(c.suburb)+', '+esc(c.state)+'</div>'
           + (phoneTxt?'<div class="meta-line">'+svg('phone',15)+'<a href="'+telHref(c.phone)+'">'+phoneTxt+'</a></div>':'')
           + '<div class="meta-line"><span class="tag-note">Non-service site · not a clinic</span></div>';
    } else if(t==='collect'){
      body = '<div class="meta-line">'+svg('bag',15)+'<span>Click &amp; Collect pickup point</span></div>'
           + '<div class="addr">'+svg('pin',15)+'<span>'+addrFull+'</span></div>'
           + (phoneTxt?'<div class="meta-line">'+svg('phone',15)+'<a href="'+telHref(c.phone)+'">'+phoneTxt+'</a>'+phoneNote+'</div>':'');
      actions = '<a class="ico-act" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">'+svg('nav',14)+'Get directions</a>'
              + '<a class="link-out" href="#/store/'+esc(c.slug)+'">About this point '+svg('chev',15)+'</a>';
    } else if(t==='sleep'){
      body = '<div class="meta-line">'+svg('moon',15)+'<span>Sleep study &amp; clinical services</span></div>'
           + '<div class="addr">'+svg('pin',15)+'<span>'+esc(c.suburb)+', '+esc(c.state)+' '+esc(c.postcode)+'</span></div>'
           + (phoneTxt?'<div class="meta-line">'+svg('phone',15)+'<a href="'+telHref(c.phone)+'">'+phoneTxt+'</a>'+phoneNote+'</div>':'');
      actions = '<a class="link-out external" href="'+(c.clm_url||CLM_FALLBACK)+'" target="_blank" rel="noopener">View clinic details &amp; book at CLM Sleep '+svg('ext',15)+'</a>';
    } else { // brand — richest card
      body = '<div class="addr">'+svg('pin',15)+'<span>'+addrFull+'</span></div>'
           + '<div class="meta-line">'+svg('clock',15)+'<span>Mon–Fri 9:00am – 5:00pm</span></div>'
           + '<div class="meta-line">'+svg('phone',15)+'<a href="'+telHref(c.phone)+'">'+phoneTxt+'</a></div>';
      actions = '<a class="ico-act" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">'+svg('nav',14)+'Get directions</a>'
              + '<a class="link-out" href="#/store/'+esc(c.slug)+'">Visit store page '+svg('chev',15)+'</a>';
    }

    var dual = c.dualNote ? '<div class="dual-note">'+svg('info',14)+esc(c.dualNote)+'</div>' : '';

    return '<li><article class="loc-card '+t+(c.slug===activeSlug?' is-active':'')+'" data-slug="'+esc(c.slug)+'" tabindex="0" role="button" aria-label="'+esc(c.name)+', '+esc(c.suburb)+'">'
      + '<span class="type-rail"></span>'
      + head + title + host + body + dual
      + (actions?'<div class="card-actions">'+actions+'</div>':'')
      + '</article></li>';
  }

  function renderList(){
    var list = document.getElementById('store-list');
    var vis = visibleCards();
    var countEl = document.getElementById('result-count'), subEl = document.getElementById('result-sub');

    if(vis.length===0){
      list.innerHTML = '<li><div class="list-empty">'+svg('search',34)+'<b>No locations match</b><span>Try a different suburb, postcode, or clear the filters.</span></div></li>';
      countEl.textContent='No matches'; subEl.textContent='';
      return;
    }

    if(nearestMode && userLoc){
      vis.sort(function(a,b){ return a.distanceKm-b.distanceKm; });
      countEl.textContent = vis.length+' location'+(vis.length>1?'s':'')+' near you';
      subEl.textContent = 'Closest first';
      list.innerHTML = vis.map(cardHTML).join('');
    } else {
      // group by state
      var groups = {};
      vis.forEach(function(c){ (groups[c.state]=groups[c.state]||[]).push(c); });
      var rank = { brand:0, collect:1, sleep:2, warehouse:3 };
      var order = STATE_ORDER.filter(function(s){ return groups[s]; })
        .concat(Object.keys(groups).filter(function(s){ return STATE_ORDER.indexOf(s)<0; }));
      var html='';
      order.forEach(function(st){
        var arr = groups[st].sort(function(a,b){ return (rank[a.cls]-rank[b.cls]) || a.suburb.localeCompare(b.suburb); });
        html += '<li class="state-group"><div class="state-head"><h2>'+esc(STATE_FULL[st]||st)+'</h2><span class="line"></span><span class="n">'+arr.length+'</span></div></li>';
        html += arr.map(cardHTML).join('');
      });
      list.innerHTML = html;
      countEl.textContent = vis.length+' location'+(vis.length>1?'s':'');
      subEl.textContent = 'Grouped by state';
    }
    document.getElementById('reset-view').style.display = (nearestMode||searchQ||!allTypesOn()) ? '' : 'none';
  }
  function allTypesOn(){ return ['brand','sleep','collect','warehouse'].every(function(k){ return COUNTS[k]===0 || activeTypes[k]; }); }

  /* ============================================================
     MAP (Leaflet)
     ============================================================ */
  var map=null, markers={}, userMarker=null, mapReady=false;
  function pinIcon(c, active){
    return L.divIcon({
      className:'', html:'<div class="cdw-pin '+c.cls+(active?' is-active':'')+'">'+svg(TYPE[c.type].icon, c.cls==='brand'?18:14)+'</div>',
      iconSize:[c.cls==='brand'?34:26, c.cls==='brand'?34:26],
      iconAnchor:[c.cls==='brand'?17:13, c.cls==='brand'?34:26],
      popupAnchor:[0, c.cls==='brand'?-34:-26]
    });
  }
  function popupHTML(c){
    var inner = '<div class="pop"><span class="pop-type" style="color:'+TYPE[c.type].color+'">'+TYPE[c.type].label+'</span>'
      + '<b>'+esc(c.name)+'</b><div class="pop-addr">'+esc(c.host?c.host+', ':'')+esc(c.suburb)+' '+esc(c.state)+'</div>';
    if(c.type==='brand') inner += '<a class="pop-link" href="#/store/'+esc(c.slug)+'">Visit store page →</a>';
    else if(c.type==='partner_sleep') inner += '<a class="pop-link" href="'+(c.clm_url||CLM_FALLBACK)+'" target="_blank" rel="noopener">Book at CLM Sleep ↗</a>';
    else if(c.type==='partner_clickcollect') inner += '<a class="pop-link" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">Get directions →</a>';
    else inner += '<span class="pop-addr">Non-service site</span>';
    return inner+'</div>';
  }
  function initMap(){
    if(typeof L==='undefined'){ document.getElementById('map-fallback').classList.add('show'); document.getElementById('map-legend').setAttribute('aria-hidden','true'); return; }
    map = L.map('map',{ scrollWheelZoom:false, zoomControl:true }).setView([-30.5,135],4);
    L.control.scale({imperial:false}).addTo(map);
    var layer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
      maxZoom:19, attribution:'&copy; OpenStreetMap contributors'
    });
    layer.on('tileerror', function(){ /* tiles blocked — markers still position correctly */ });
    layer.addTo(map);
    map.on('click', function(){ map.scrollWheelZoom.enable(); });

    var bounds=[];
    CARDS.forEach(function(c){
      var m = L.marker([c.lat,c.lng],{ icon:pinIcon(c,false), riseOnHover:true, keyboard:true, title:c.name, zIndexOffset:(c.cls==='brand'?1000:(c.cls==='warehouse'?-200:0)) });
      m.bindPopup(popupHTML(c));
      m.on('click', function(){ selectCard(c.slug,false); });
      m.addTo(map); markers[c.slug]=m; bounds.push([c.lat,c.lng]);
    });
    if(bounds.length) map.fitBounds(bounds,{ padding:[40,40] });
    mapReady=true;
    document.getElementById('map-legend').setAttribute('aria-hidden','false');
  }

  function refreshMarkers(){
    if(!mapReady) return;
    var vis = {}; visibleCards().forEach(function(c){ vis[c.slug]=1; });
    CARDS.forEach(function(c){
      var m = markers[c.slug]; if(!m) return;
      if(vis[c.slug]){ if(!map.hasLayer(m)) m.addTo(map); }
      else { if(map.hasLayer(m)) map.removeLayer(m); }
    });
  }

  /* ============================================================
     Selection / sync between list and map
     ============================================================ */
  function selectCard(slug, fromList){
    var prev = activeSlug; activeSlug = slug;
    // update card classes
    ROOT.querySelectorAll('.loc-card').forEach(function(el){ el.classList.toggle('is-active', el.getAttribute('data-slug')===slug); });
    // update markers
    if(mapReady){
      [prev,slug].forEach(function(s){ var c=BY_SLUG[s], m=markers[s]; if(c&&m) m.setIcon(pinIcon(c, s===slug)); });
      var c = BY_SLUG[slug], m = markers[slug];
      if(c&&m){ map.setView([c.lat,c.lng], Math.max(map.getZoom(),9), { animate:!REDUCED }); m.openPopup(); }
    }
    if(fromList && mapReady){ /* map handled above */ }
    if(!fromList){
      // scroll the matching card into view within the page
      var el = ROOT.querySelector('.loc-card[data-slug="'+CSS.escape(slug)+'"]');
      if(el){ var r=el.getBoundingClientRect(); window.scrollTo({ top: window.scrollY + r.top - 150, behavior: REDUCED?'auto':'smooth' }); }
    }
  }

  /* ============================================================
     Events
     ============================================================ */
  document.getElementById('filter-chips').addEventListener('click', function(e){
    var btn = e.target.closest('.chip'); if(!btn || btn.disabled) return;
    var key = btn.getAttribute('data-chip');
    if(key==='all'){ ['brand','sleep','collect','warehouse'].forEach(function(k){ activeTypes[k]=true; }); }
    else {
      // if everything is on, clicking one isolates it; else toggle it
      if(allTypesOn()){ ['brand','sleep','collect','warehouse'].forEach(function(k){ activeTypes[k]=(k===key); }); }
      else { activeTypes[key]=!activeTypes[key]; if(['brand','sleep','collect','warehouse'].every(function(k){return !activeTypes[k];})) activeTypes[key]=true; }
    }
    renderChips(); renderList(); refreshMarkers();
  });

  var searchInput = document.getElementById('search-input'), clearBtn = document.getElementById('search-clear');
  searchInput.addEventListener('input', function(){
    searchQ = this.value.trim(); clearBtn.classList.toggle('show', !!searchQ); renderList(); refreshMarkers();
  });
  clearBtn.addEventListener('click', function(){ searchInput.value=''; searchQ=''; clearBtn.classList.remove('show'); searchInput.focus(); renderList(); refreshMarkers(); });

  document.getElementById('store-list').addEventListener('click', function(e){
    if(e.target.closest('a')) return; // let links work
    var card = e.target.closest('.loc-card'); if(!card) return;
    selectCard(card.getAttribute('data-slug'), true);
  });
  document.getElementById('store-list').addEventListener('keydown', function(e){
    var card = e.target.closest('.loc-card'); if(!card) return;
    if(e.key==='Enter' || e.key===' '){ e.preventDefault(); selectCard(card.getAttribute('data-slug'), true); }
  });

  var nearestBtn = document.getElementById('btn-nearest');
  nearestBtn.addEventListener('click', function(){
    if(nearestMode){ exitNearest(); return; }
    if(!navigator.geolocation){ alert('Geolocation isn\u2019t available in this browser.'); return; }
    nearestBtn.setAttribute('aria-busy','true'); nearestBtn.innerHTML = svg('crosshair',17)+' Locating…';
    navigator.geolocation.getCurrentPosition(function(pos){
      userLoc = { lat:pos.coords.latitude, lng:pos.coords.longitude };
      applyNearest();
    }, function(){
      nearestBtn.removeAttribute('aria-busy'); nearestBtn.innerHTML = svg('crosshair',17)+' Find nearest';
      // graceful fallback: demo from Adelaide CBD
      if(confirm('We couldn\u2019t access your location. Show locations nearest to Adelaide instead?')){ userLoc={lat:-34.9285,lng:138.6007}; applyNearest(); }
    }, { enableHighAccuracy:false, timeout:8000, maximumAge:600000 });
  });
  function applyNearest(){
    nearestMode = true;
    CARDS.forEach(function(c){ c.distanceKm = haversine(userLoc, c); });
    nearestBtn.removeAttribute('aria-busy'); nearestBtn.innerHTML = svg('x',17)+' Clear nearest';
    nearestBtn.style.background='var(--sale)'; nearestBtn.style.borderColor='var(--sale)';
    renderList();
    if(mapReady){
      if(userMarker) map.removeLayer(userMarker);
      userMarker = L.circleMarker([userLoc.lat,userLoc.lng],{ radius:8, color:'#fff', weight:3, fillColor:'#3575db', fillOpacity:1 }).addTo(map).bindPopup('You are here');
      var nearest = visibleCards().slice().sort(function(a,b){return a.distanceKm-b.distanceKm;})[0];
      var pts=[[userLoc.lat,userLoc.lng]]; if(nearest) pts.push([nearest.lat,nearest.lng]);
      map.fitBounds(pts,{ padding:[60,60], maxZoom:11 });
      if(nearest) selectCard(nearest.slug, true);
    }
  }
  function exitNearest(){
    nearestMode=false; CARDS.forEach(function(c){ delete c.distanceKm; });
    nearestBtn.innerHTML = svg('crosshair',17)+' Find nearest'; nearestBtn.style.background=''; nearestBtn.style.borderColor='';
    if(mapReady && userMarker){ map.removeLayer(userMarker); userMarker=null; }
    renderList();
    if(mapReady){ var b=[]; visibleCards().forEach(function(c){b.push([c.lat,c.lng]);}); if(b.length) map.fitBounds(b,{padding:[40,40]}); }
  }
  document.getElementById('reset-view').addEventListener('click', function(){
    searchInput.value=''; searchQ=''; clearBtn.classList.remove('show');
    ['brand','sleep','collect','warehouse'].forEach(function(k){ activeTypes[k]=true; });
    if(nearestMode) exitNearest();
    renderChips(); renderList(); refreshMarkers();
  });

  /* ============================================================
     ROUTER  (#/  and  #/store/<slug>)
     ============================================================ */
  function showView(id){
    document.getElementById('view-locator').classList.toggle('active', id==='locator');
    document.getElementById('view-store').classList.toggle('active', id==='store');
  }
  function router(){
    var h = location.hash || '#/';
    var m = h.match(/^#\/store\/(.+)$/);
    if(m && BY_SLUG[decodeURIComponent(m[1])]){
      renderStorePage(BY_SLUG[decodeURIComponent(m[1])]); showView('store'); window.scrollTo(0,0);
    } else {
      showView('locator');
      if(map) setTimeout(function(){ map.invalidateSize(); }, 60);
    }
  }
  window.addEventListener('hashchange', router);

  /* ---------- Store page template ---------- */
  function nearbyOf(c, n){
    return CARDS.filter(function(x){ return x.slug!==c.slug; })
      .map(function(x){ return { c:x, d:haversine(c,x) }; })
      .sort(function(a,b){ return a.d-b.d; }).slice(0, n||4);
  }
  function osmEmbed(c){
    var d=0.02, bbox=[(c.lng-d),(c.lat-d),(c.lng+d),(c.lat+d)].join('%2C');
    return 'https://www.openstreetmap.org/export/embed.html?bbox='+bbox+'&layer=mapnik&marker='+c.lat+'%2C'+c.lng;
  }
  function quickFact(ic, warm, label, body){
    return '<div class="qf"><div class="qf-ic'+(warm?' warm':'')+'">'+svg(ic,19)+'</div><div class="qf-body"><b>'+label+'</b>'+body+'</div></div>';
  }

  function renderStorePage(c){
    var isNative = (c.type==='brand' || c.type==='warehouse');
    var el = document.getElementById('store-content');
    var crumbs = '<nav class="crumbs" aria-label="Breadcrumb"><a href="#/">Home</a> '+svg('chev',14).replace('viewBox','style="transform:rotate(-90deg)" viewBox')
      +' <a href="#/">Store locator</a> '+svg('chev',14).replace('viewBox','style="transform:rotate(-90deg)" viewBox')+' <span>'+esc(c.name)+'</span></nav>';

    if(isNative){ el.innerHTML = crumbs + nativeStore(c); }
    else { el.innerHTML = crumbs + partnerStore(c); }
    el.querySelectorAll('[data-icon]').forEach(function(x){ x.innerHTML = svg(x.getAttribute('data-icon'),18); });
  }

  function nativeStore(c){
    var addrFull = esc(c.street)+'<br/>'+esc(c.suburb)+' '+esc(c.state)+' '+esc(c.postcode);
    var hours = [['Monday','9:00am – 5:00pm'],['Tuesday','9:00am – 5:00pm'],['Wednesday','9:00am – 5:00pm'],['Thursday','9:00am – 5:00pm'],['Friday','9:00am – 5:00pm'],['Saturday','Closed'],['Sunday','Closed']];
    var todayIdx = (new Date().getDay()+6)%7;
    var hoursRows = hours.map(function(r,i){ return '<tr class="'+(i===todayIdx?'today':'')+'"><td>'+r[0]+'</td><td>'+r[1]+'</td></tr>'; }).join('');

    var services = [
      ['bed','In-store mask fitting','Try nasal, pillow and full-face masks with a consultant and walk out with the right seal.'],
      ['building','Machine setup &amp; data download','We configure your CPAP, pull therapy data and explain your AHI in plain language.'],
      ['headset','CPAP consultant on site','No appointment needed — real, experienced advice without the pressure.'],
      ['bag','Click &amp; Collect','Order online and collect from the Elizabeth counter, usually same day.'],
      ['heart','Resupply &amp; reorders','Restock cushions, filters and tubing on your therapy schedule — pop in or set up a reminder.'],
      ['file','Rebate &amp; paperwork help','We\u2019ll help with health-fund claims and the paperwork that comes with therapy.']
    ].map(function(s){ return '<div class="svc"><div class="svc-ic">'+svg(s[0],18)+'</div><div><b>'+s[1]+'</b><span>'+s[2]+'</span></div></div>'; }).join('');

    return '<div class="store-hero">'
      + '<div>'
        + '<div class="badge-row">'+typeBadge('brand')+'<span style="font-size:12px;font-weight:600;color:var(--gold-ink);background:var(--cream);padding:5px 11px;border-radius:100px;">South Australian owned</span></div>'
        + '<h1 id="store-h1">CPAP Discount Warehouse — '+esc(c.name)+'</h1>'
        + '<p class="sub-loc">Our retail &amp; fitting store &amp; warehouse · '+esc(c.suburb)+', '+esc(c.state)+'</p>'
        + '<div class="quickfacts">'
          + quickFact('pin',false,'Address','<span>'+addrFull+'</span>')
          + quickFact('phone',false,'Phone','<a href="'+telHref(c.phone)+'">'+fmtPhone(c.phone)+'</a>')
          + quickFact('clock',true,'Opening hours','<table class="hours-table">'+hoursRows+'</table>')
        + '</div>'
      + '</div>'
      + '<aside class="store-cta-card">'
        + '<p class="price-line">Genuine ResMed, Fisher &amp; Paykel &amp; Philips · TGA-regulated · 5% Price-Beat Guarantee</p>'
        + '<a class="btn btn-cta" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">'+svg('nav',18)+'Get directions</a>'
        + '<a class="btn btn-primary" href="'+telHref(c.phone)+'">'+svg('phone',18)+'Call the store</a>'
        + '<a class="btn btn-secondary" href="#/">'+svg('headset',18)+'Talk to a consultant</a>'
        + '<div class="store-map"><iframe loading="lazy" title="Map of '+esc(c.name)+'" src="'+osmEmbed(c)+'"></iframe></div>'
      + '</aside>'
      + '</div>'
      + '<section class="store-section"><h2>What you can do here</h2><p class="lede">Elizabeth is our only full-service retail counter — everything from a first fitting to ongoing resupply and rebate help.</p><div class="services-grid">'+services+'</div></section>'
      + '<section class="store-section"><h2>About this store</h2><div class="about-blurb">'
        + '<p>Our Elizabeth store sits inside Northern Respiratory on Philip Highway, a short drive north of the Adelaide CBD. It\u2019s where the CPAP Discount Warehouse story started, and it\u2019s still the only place you can sit down with a consultant, try every mask style on the shelf, and have your machine set up and checked the same day.</p>'
        + '<p>Newly diagnosed and not sure where to start? Bring your sleep study and we\u2019ll walk you through your options without the jargon. Already on therapy and just need supplies? Park out front, grab your Click &amp; Collect order and you\u2019re on your way. Either way, you\u2019re talking to people who do this every day.</p>'
        + '</div></section>'
      + nearbySection(c);
  }

  function partnerStore(c){
    var isCollect = c.type==='partner_clickcollect';
    var addrFull = esc(c.street)+'<br/>'+esc(c.suburb)+' '+esc(c.state)+' '+esc(c.postcode);
    var phoneNote = isShared(c.phone) ? ' <span style="color:var(--text-3);font-size:12px;">(CLM Sleep bookings)</span>' : '';
    var roleLine = isCollect ? 'a Click &amp; Collect pickup point' : 'a CLM Sleep clinic partner';
    var summary = isCollect
      ? 'You can collect online CPAP orders from '+esc(c.host||c.suburb)+' in '+esc(c.suburb)+'. Place your order at cpapdiscount.au, choose Click &amp; Collect, and we\u2019ll let you know when it\u2019s ready to pick up.'
      : 'This is one of our CLM Sleep clinic partners in '+esc(c.suburb)+', offering sleep studies and clinical follow-up. Bookings, hours, clinician details and the full service list are managed by CLM Sleep on their own site.';

    return '<div class="store-hero">'
      + '<div>'
        + '<div class="badge-row">'+typeBadge(c.cls)+(c.dualNote?'<span style="font-size:12px;font-weight:600;color:var(--t-collect-ink);background:var(--t-collect-bg);padding:5px 11px;border-radius:100px;">'+esc(c.dualNote)+'</span>':'')+'</div>'
        + '<h1 id="store-h1">'+esc(c.name)+'</h1>'
        + '<p class="sub-loc">'+(c.host?esc(c.host)+' · ':'')+esc(c.suburb)+', '+esc(c.state)+' — '+roleLine+'</p>'
        + '<div class="quickfacts">'
          + quickFact('pin',false,'Address','<span>'+addrFull+'</span>')
          + (fmtPhone(c.phone)?quickFact('phone',false,'Phone','<a href="'+telHref(c.phone)+'">'+fmtPhone(c.phone)+'</a>'+phoneNote):'')
        + '</div>'
      + '</div>'
      + '<aside class="store-cta-card">'
        + '<p class="price-line">'+(isCollect?'Order online · collect locally · 5% Price-Beat Guarantee':'Sleep studies &amp; clinical care via our CLM Sleep partner network')+'</p>'
        + (isCollect
            ? '<a class="btn btn-cta" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">'+svg('nav',18)+'Get directions</a><a class="btn btn-primary" href="#/">'+svg('bag',18)+'Shop &amp; choose Click &amp; Collect</a>'
            : '<a class="btn btn-cta" href="'+(c.clm_url||CLM_FALLBACK)+'" target="_blank" rel="noopener">'+svg('ext',18)+'Full details &amp; booking at CLM Sleep</a><a class="btn btn-primary" href="'+directionsUrl(c)+'" target="_blank" rel="noopener">'+svg('nav',18)+'Get directions</a>')
        + '<div class="store-map"><iframe loading="lazy" title="Map of '+esc(c.name)+'" src="'+osmEmbed(c)+'"></iframe></div>'
      + '</aside>'
      + '</div>'
      + '<section class="store-section"><h2>About this location</h2><div class="about-blurb"><p>'+summary+'</p></div>'
        + (!isCollect
          ? '<div class="partner-callout"><div class="pc-body"><h3>Managed by CLM Sleep</h3><p>Hours, clinicians and bookings for '+esc(c.suburb)+' live on the CLM Sleep website. We link out rather than copy their details, so you always get the most accurate, up-to-date information.</p></div><a class="btn btn-cta" href="'+(c.clm_url||CLM_FALLBACK)+'" target="_blank" rel="noopener">'+svg('ext',18)+'Full details &amp; booking at CLM Sleep for '+esc(c.suburb)+'</a></div>'
          : '')
        + '</section>'
      + nearbySection(c);
  }

  function nearbySection(c){
    var nb = nearbyOf(c,4).map(function(x){
      var t=x.c, label=TYPE[t.type].label;
      var href = '#/store/'+esc(t.slug);
      return '<a class="nearby-card" href="'+href+'"><span class="nb-type" style="color:'+TYPE[t.type].color+'">'+label+'</span><b>'+esc(t.name)+'</b><span>'+esc(t.suburb)+', '+esc(t.state)+'</span><div class="nb-dist">'+fmtDist(x.d)+' away</div></a>';
    }).join('');
    return '<section class="store-section"><h2>Nearby locations</h2><p class="lede">Other CPAP Discount Warehouse stores and partners closest to '+esc(c.suburb)+'.</p><div class="nearby-strip">'+nb+'</div>'
      + '<p style="margin-top:22px;"><a class="btn btn-secondary" href="#/">'+svg('map',18)+' Back to the full locator map</a></p></section>';
  }

  /* ============================================================
     INIT
     ============================================================ */
  renderChips();
  renderList();
  initMap();
  router();
})();
